module.exports = __webpack_public_path__ + "img/couples-062.839282f0.jpg";